import React from 'react';
import './Galloncaps.css';
import gallon from '../../../imgs/gallons.webp';

const Galloncaps = () => {
    return (
        <div className="Cavity-container">
            <div className='Cavitys'>
                <div className="Cavity">
                    <img src={gallon} alt="72 Cavity PET Preforms Machine" className="Cavity-image" />
                    <div className="Cavity-content">
                        <h2 className="Cavity-title">In the Video Below</h2>
                        <p className="Cavity-date">Disha KII288-S7</p>
                        <p className="Cavity-text">
                            high-precision injection molding machine produces 5 gallon caps with high molding stability. The optimized injection mechanism reduces the injection resistance and improves the speed and accuracy of the product. In the pursuit of cost optimization and profit maximization,
                            effectively provide customers with continuous competitiveness.
                        </p>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Galloncaps;
